<!-- TODO: Add MessagesDrawer component when ready -->
<!-- <app-messages-drawer [open]="messagesOpen()" (openChange)="setMessagesOpen($event)" /> -->

<nav class="border-border sticky top-0 z-50 border-b bg-white">
  <div class="mx-auto max-w-[1600px] px-6 py-4 lg:px-12">
    <div class="flex items-center justify-between">
      <!-- Logo -->
      <a
        routerLink="/"
        class="flex cursor-pointer items-center gap-2 transition-opacity hover:opacity-80"
      >
        <div class="flex items-center justify-center">
          <img
            src="logo-132x132.png"
            width="132"
            height="132"
            alt="Hire - My Motorhome Logo"
            class="h-10 w-10 object-contain"
          />
        </div>
        <span class="text-foreground text-lg whitespace-nowrap">Hire - My Motorhome</span>
        @if (isDevelopment) {
          <span
            class="ml-2 flex items-center gap-1.5 rounded-full bg-yellow-400 px-2.5 py-1 text-xs font-semibold text-yellow-900"
          >
            <svg class="h-3.5 w-3.5" fill="currentColor" viewBox="0 0 20 20">
              <path
                fill-rule="evenodd"
                d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 5a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 5zm0 9a1 1 0 100-2 1 1 0 000 2z"
                clip-rule="evenodd"
              />
            </svg>
            DEV
          </span>
        }
      </a>

      <!-- Desktop Navigation -->
      <div class="hidden items-center gap-6 whitespace-nowrap md:flex">
        <a
          routerLink="/search"
          class="text-text-secondary hover:text-secondary cursor-pointer transition-colors"
        >
          Explore
        </a>
        <a
          routerLink="/destinations"
          class="text-text-secondary hover:text-secondary cursor-pointer transition-colors"
        >
          Destinations
        </a>
        <a
          routerLink="/list-your-motorhome"
          class="text-text-secondary hover:text-secondary cursor-pointer transition-colors"
        >
          List your motorhome
        </a>
      </div>

      <!-- Right Side Actions -->
      <div class="flex items-center justify-end gap-3">
        @if (isLoggedIn()) {
          <!-- Favorites Button -->
          <a
            routerLink="/favorites"
            routerLinkActive="bg-gray-200"
            class="hidden h-10 w-10 cursor-pointer items-center justify-center rounded-full transition-all hover:scale-110 hover:bg-gray-200 active:scale-95 md:flex"
            aria-label="Favorites"
          >
            <svg [lucideIcon]="HeartIcon" class="h-5 w-5"></svg>
          </a>

          <!-- Notifications Bell -->
          <div class="relative">
            <button
              (click)="toggleNotifications()"
              class="hidden h-10 w-10 cursor-pointer items-center justify-center rounded-full transition-all hover:scale-110 hover:bg-gray-200 active:scale-95 md:flex"
              [class.bg-gray-200]="notificationsOpen()"
              aria-label="Notifications"
            >
              <svg
                [lucideIcon]="BellIcon"
                class="h-5 w-5"
                [class.animate-wiggle]="unreadNotificationsCount() > 0"
              ></svg>
            </button>
            @if (unreadNotificationsCount() > 0) {
              <span
                class="animate-scale-in absolute -top-0.5 -right-0.5 hidden h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1 text-xs font-semibold text-white md:flex"
              >
                {{ unreadNotificationsCount() }}
              </span>
            }
          </div>

          <!-- Messages Button -->
          <div class="relative">
            <button
              (click)="toggleMessages()"
              class="hidden h-10 w-10 cursor-pointer items-center justify-center rounded-full transition-all hover:scale-110 hover:bg-gray-200 active:scale-95 md:flex"
              aria-label="Messages"
              [class.bg-gray-200]="messagesOpen()"
            >
              <svg
                [lucideIcon]="MessageCircleIcon"
                class="h-5 w-5"
                [class.animate-wiggle]="unreadCount() > 0"
              ></svg>
            </button>
            @if (unreadCount() > 0) {
              <span
                class="animate-scale-in absolute -top-0.5 -right-0.5 hidden h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1 text-xs font-semibold text-white md:flex"
              >
                {{ unreadCount() }}
              </span>
            }
          </div>

          <!-- Admin: Inbox (New) -->
          @if (isAdmin()) {
            <div class="relative">
              <!-- <a
                routerLink="/admin/inbox"
                class="hidden h-10 w-10 cursor-pointer items-center justify-center rounded-full transition-all hover:scale-110 hover:bg-gray-200 active:scale-95 md:flex"
                routerLinkActive="bg-gray-200"
                aria-label="Inbox"
              >
                <svg
                  [lucideIcon]="Mail2Icon"
                  class="h-5 w-5"
                  [class.animate-wiggle]="newContactMessagesCount() > 0"
                >
                </svg>
              </a> -->
              @if (newContactMessagesCount() > 0) {
                <span
                  class="animate-scale-in absolute -top-0.5 -right-0.5 hidden h-5 min-w-5 items-center justify-center rounded-full bg-red-600 px-1 text-xs font-semibold text-white md:flex"
                >
                  {{ newContactMessagesCount() }}
                </span>
              }
            </div>
          }

          <!-- User Menu Dropdown -->
          <div
            class="relative"
            (document:click)="onDocumentClick($event)"
            (keydown)="onDocumentClick($event)"
            tabindex="0"
          >
            <button
              (click)="toggleUserMenu()"
              class="border-border hover:bg-accent flex cursor-pointer items-center gap-2 rounded-full border px-4 py-2 transition-all hover:scale-105 hover:shadow-md active:scale-95"
              aria-label="User menu"
            >
              <svg [lucideIcon]="MenuIcon" class="h-4 w-4"></svg>
              <svg [lucideIcon]="UserIcon" class="h-5 w-5"></svg>
            </button>

            @if (userMenuOpen()) {
              <div
                class="border-border animate-scale-in absolute right-0 z-50 mt-2 min-w-max rounded-md border bg-white py-1 shadow-lg"
              >
                <!-- User Email Header -->
                @if (currentUser()?.email) {
                  <div class="border-b border-gray-200 px-4 py-3">
                    <p class="truncate text-sm font-medium text-gray-900">
                      {{ currentUser()?.email }}
                    </p>
                  </div>
                }
                @for (option of filteredMenuOptions(); track $index) {
                  @if (option.label === 'Separator') {
                    <hr [class]="'my-1 border-gray-200 ' + (option.class || '')" />
                  } @else if (option.route) {
                    <a
                      [routerLink]="'/' + option.route"
                      (click)="closeUserMenu()"
                      [class]="
                        'relative flex w-full cursor-pointer items-center px-4 py-2 text-left text-sm whitespace-nowrap transition-colors ' +
                        (option.class && option.class.includes('text-red-600')
                          ? option.class
                          : (option.class || '') + ' text-gray-700 hover:bg-gray-100')
                      "
                    >
                      <svg [lucideIcon]="option.icon ?? null" class="mr-3 h-4 w-4"></svg>
                      {{ option.label }}
                      @if (option.label === 'Messages' && unreadCount() > 0) {
                        <span
                          class="mr-2 ml-5 flex h-5 min-w-5 items-center justify-center rounded-full bg-indigo-600 px-1 text-xs"
                        >
                          {{ unreadCount() }}
                        </span>
                      }
                    </a>
                  } @else {
                    <button
                      (click)="onMenuItemClick(option)"
                      [class]="
                        'relative flex w-full scale-100! cursor-pointer items-center justify-start! rounded-none! px-4 py-2 text-left text-sm whitespace-nowrap shadow-none! transition-colors ' +
                        (option.class && option.class.includes('text-red-600')
                          ? option.class
                          : (option.class || '') + ' text-gray-700 hover:bg-gray-100')
                      "
                    >
                      <svg [lucideIcon]="option.icon ?? null" class="mr-3 h-4 w-4"></svg>
                      {{ option.label }}
                    </button>
                  }
                }
              </div>
            }
          </div>
        } @else {
          <!-- Sign In Button -->
          <button
            (click)="onSignIn()"
            class="border-border hover:bg-accent flex cursor-pointer items-center gap-2 rounded-full border px-4 py-2 transition-all hover:scale-105 hover:shadow-md active:scale-95"
            aria-label="Sign in"
          >
            <svg [lucideIcon]="UserIcon" class="h-5 w-5"></svg>
            <span class="text-sm">Sign In</span>
          </button>
        }
      </div>
    </div>
  </div>
</nav>

<!--
  Drawers gated to logged-in users only — both features require an account.
  Wrapping in @if before @defer prevents the prefetch chunks from loading
  for anonymous visitors (who can never open the drawers anyway), preserving
  the landing-page byte savings for paid social traffic.
-->
@if (isLoggedIn()) {
  <!-- Messages Drawer (deferred — pulls in Firebase Realtime DB SDK ~126 KB) -->
  @defer (when messagesOpen(); prefetch on idle) {
    <app-messages-drawer
      [open]="messagesOpen()"
      (openChange)="setMessagesOpen($event)"
      (navigate)="onNavigate($event)"
    />
  }

  <!-- Notifications Drawer (deferred until opened) -->
  @defer (when notificationsOpen(); prefetch on idle) {
    <app-notifications-drawer
      [open]="notificationsOpen()"
      (openChange)="setNotificationsOpen($event)"
    />
  }
}
